export default {
  searchResult: state => {
    return state.searchResult
  },
  loading: state => {
    return state.loading
  },
  sortOptions: state => {
    return state.sortOptions
  },
  page: state => {
    return state.page
  },
  filter: state => {
    return state.filter
  },
  selectedItems: state => {
    return state.selectedItems
  },
  approvableItems: state => {
    return state.searchResult.items.filter(item => item.isApprovable)
  },
  selectedApprovableItems: state => {
    return state.selectedItems.filter(item => item.isApprovable)
  },
}
